import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const Star = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6.76914 14.6996L5.53431 21.8992L12 18.5L18.4656 21.8992L17.2308 14.6996L22.4616 9.60081L15.2328 8.55041L12 2L8.76713 8.55041L1.53833 9.60081L6.76914 14.6996ZM16.1563 14.3505L17.1375 20.0712L12 17.3702L6.86244 20.0712L7.84362 14.3505L3.68729 10.2991L9.4312 9.46441L12 4.25955L14.5687 9.46441L20.3126 10.2991L16.1563 14.3505Z"
  />,
  'Star'
)

export default Star
